import HeaderComponent from './HeaderComponent';
import FrontPage from './FrontPage';
import FooterComponent from './FooterComponent';
import useBodyClass from "../UseBodyClass"
import { useScroll } from '../HelperRepository';
import MainComponent from './MainComponent';
import CategoryPreview from './CategoryPreview';
import configData from '../config.json';

const BodyComponent = ({ setActiveCategory,
    setCategories,
    setCategoryList,
    categoryList,
    setActiveVideo,
    shouldLoad,
    activeVideo,
    activeCategory
}) => {

    useScroll(shouldLoad);

    
    if((configData.BRAND).toUpperCase() === 'DELO'){
        useBodyClass([`d-video-delo`]);
        var imgSrcBrand = configData.DELO.LOGO;
        var altImgBrand = configData.DELO.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-delo-logo";
    }
    else {
        useBodyClass([`d-video-novice`]);
        var imgSrcBrand = configData.SLOVENSKENOVICE.LOGO;
        var altImgBrand = configData.SLOVENSKENOVICE.ALTIMG;
        var imgClassNameBrand = "d-logo-header d-novice-logo";
    }
    
    return (
        <>
            <HeaderComponent categoryList={categoryList} setActiveCategory={setActiveCategory} activeCategory={activeCategory} setActiveVideo={setActiveVideo}>
                {shouldLoad && (
                    <>
                        <FrontPage setActiveCategory={setActiveCategory}
                            setCategoryList={setCategoryList}
                            categoryList={categoryList}
                            setActiveVideo={setActiveVideo}
                            activeVideo={activeVideo}>
                        </FrontPage>
                    </>
                )}
            </HeaderComponent>
            <>
                <MainComponent shouldLoad={shouldLoad}>
                {shouldLoad && (
                    <>
                    <h1 className="d-visually-sleep">Delo Video Portal</h1>
                    <section id="" className="d-section d-video-list">
                        {categoryList && categoryList.map((item) => (
                            <CategoryPreview key={item.id}
                                category={item}
                                setActiveCategory={setActiveCategory}
                                setActiveVideo={setActiveVideo} />
                        ))}
                    </section>
                    </>
                )}
                </MainComponent>
            </>
            <FooterComponent categoryList={categoryList} setActiveCategory={setActiveCategory} setActiveVideo={setActiveVideo}></FooterComponent>

            {/* Preloader */}
            {!shouldLoad && (
                <div id="preloader" className="preloader d-bg-transparent-85">
                    <img src={imgSrcBrand} className={imgClassNameBrand} alt={altImgBrand}/>
                </div>
            )}
        </>
    );
};

export default BodyComponent;